<footer *ngIf="!isMobileRender" class="footer">
  <div class="footer-info">
    <div class="footer-info-logo">
      <img src="https://static.zip.co/logo/zip-logo.svg" alt="ZipCo" />
      <span>Copyright © Zip Co Limited {{ year }}.</span>
    </div>
    <div class="footer-info-social">
      <a class="social-media-icon" href="https://www.instagram.com/zip_au">
        <img
          async
          src="https://static.zip.co/assets/socials/instagram-icon.svg"
          alt="instagram"
        />
      </a>
      <a class="social-media-icon" href="https://www.facebook.com/zipAU">
        <img async src="https://static.zip.co/assets/socials/facebook-icon.svg" alt="facebook" />
      </a>
      <a class="social-media-icon" href="https://www.linkedin.com/company/zip-co-limited">
        <img async src="https://static.zip.co/assets/socials/linkedin-icon.svg" alt="linkedin" />
      </a>
    </div>
  </div>
</footer>
